import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from '@/i18n/client';
import { useParams } from 'next/navigation';
import { Locale } from '../../../../../i18n-config';
import { useMediaQuery } from '@uidotdev/usehooks';
import Link from 'next/link';

function MapView(props) {
  return (
    <div className="col-md-6 mb-3">
      {/*<p className="">{t("sort by")}:</p>*/}
      <button
        style={
          !props.mapView
            ? {
                background: 'white',
                border: 'none',
                boxShadow: '1px 2px #e3e1e1',
              }
            : {
                background: 'white',
                border: 'none',
                boxShadow: '1px 2px #e3e1e1',
                fontWeight: 'bold',
              }
        }
        onClick={props.onClick}
        className="btn btn-light w-100"
      >
        {props.s}
      </button>
    </div>
  );
}

MapView.propTypes = {
  mapView: PropTypes.any,
  onClick: PropTypes.func,
  s: PropTypes.any,
};

function ImageView(props) {
  return (
    <div className="col-md-6 mb-3">
      {/*<p className="">{t("sort by")}:</p>*/}

      <button
        style={
          props.mapView
            ? {
                background: 'white',
                border: 'none',
                boxShadow: '1px 2px #e3e1e1',
              }
            : {
                background: 'white',
                border: 'none',
                boxShadow: '1px 2px #e3e1e1',
                fontWeight: 'bold',
              }
        }
        onClick={props.onClick}
        className="btn btn-light w-100"
      >
        {props.s}
      </button>
    </div>
  );
}

ImageView.propTypes = {
  mapView: PropTypes.any,
  onClick: PropTypes.func,
  s: PropTypes.any,
};
const SearchTourButtons = ({ setMapView, map_view, handleResetFilters }) => {
  const { lang } = useParams();
  const { t, i18n } = useTranslation(lang as Locale);
  const isMobile = useMediaQuery('only screen and (max-width : 768px)');

  return (
    <>
      <div className="row">
        {!isMobile && <MapView mapView={map_view} onClick={() => setMapView(true)} s={t('Map view')} />}
        <div className={`col-md-6 mb-3`}>
          <Link href="/tailor-made-iran-tours">
            <button className="btn w-100 btn btn-timnak">{t('Customize your own trip ')}</button>
          </Link>
        </div>
        {!isMobile && <ImageView mapView={map_view} onClick={() => setMapView(false)} s={t('Image view')} />}
        <div className={`col-md-6 mb-3`}>
          {/* <Link to="/Iran-tours-search"> */}
          <button className="btn w-100 btn btn-timnak" onClick={() => handleResetFilters()}>
            {t('View all tours')}
          </button>
          {/* </Link> */}
        </div>
      </div>
    </>
  );
};

export default SearchTourButtons;
